import React, { Component } from 'react'
import { Modal, Tabs, Image, Row, Button, Card } from 'antd';
import PlaneInfoBox from './PlaneInfoBox'
import PlaneTrackMap from './PlaneTrackMap'
import PlaneStatistic from './PlaneStatistic'
import PlaneTypeInfoBox from './PlaneTypeInfoBox'
import axios from 'axios';
import { osintRequestAddress } from '../config'

const { TabPane } = Tabs;

const countryDict = {
    "United States":"美国",
    "Japan":"日本",
    "Taiwan":"台湾",
    "South Korea":"韩国",
    "India":"印度",
    "Australia":"澳大利亚",
    "Russia":"俄罗斯",
}

export default class PlaneDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            planeInfo: {},
            photos: [],
            tweets: [],
            planeinfobox: [],
            recenttracks: [],
            planetypewiki: {},
            typeInfoBox: [],
        }
    }

    componentDidMount(){
        const { plane } = this.props
        this.sendPlaneRequests(plane)
    }

    sendPlaneRequests = (plane) => {
        if (plane.reg){
            axios.get(`${osintRequestAddress}/plane/photo?reg=` + plane.reg).then(
                response => {
                    if (response.data && response.data.length > 0){
                        this.setState({ photos: response.data.slice(0,10) })
                    }
                },
                error => {
                    console.log("error",error)
                }
            )    
            axios.get(`${osintRequestAddress}/kg?reg=` + plane.reg).then(
            response => {
                if (response.data){
                    this.setState({
                        planeinfobox: response.data.infobox
                    })
                    if (response.data.relatedNodes && response.data.relatedNodes.length>0){
                        response.data.relatedNodes.map(e=>{
                            if(e.relation === "隶属于"){
                                axios.get(`${osintRequestAddress}/wiki?article=`+e.wiki.split("wiki/")[e.wiki.split("wiki/").length-1]).then(
                                    response => {
                                        if (response.data){
                                            this.setState({
                                                planetypewiki: response.data
                                            })
                                        }                        
                                    },
                                    error => {console.log("error",error)}
                                    )
                                axios.get(`${osintRequestAddress}/kg?qcode=`+e.qcode).then(
                                response => {
                                    if (response.data){
                                        this.setState({
                                            typeInfoBox: response.data.infobox
                                        })
                                    }                      
                                },
                                error => {console.log("error",error)}
                                )
                            }
                            return ""
                        })
                    }
                }                      
            },
            error => {console.log("error",error)}
            )
            axios.get(`${osintRequestAddress}/plane/recenttrack?reg=`+plane.reg).then(
            response => {
                if (response.data){
                    this.setState({
                        recenttracks: response.data
                    })
                }                      
            },
            error => {console.log("error",error)}
            )
        }
    }


    render(){
        const { plane } = this.props
        var force = "", regStr = ""
        if (this.state.planeInfo.cou==="United States" && this.state.planeInfo.reg){
            if (this.state.planeInfo.reg.includes("-")){
                force = "空军"
            }else{
                force = "海军"
            }
        }
        if (this.state.planeInfo.reg){
            regStr = "注册号：" +this.state.planeInfo.reg
        }else{
            regStr = ""
        }
        const titleText = countryDict[plane.cou] + force + plane.type + "  ("+ regStr + "  icao：" + plane.icao + ")"
        return ( 
            <Modal key={plane.reg} title={titleText} maskClosable={false} width={'70vw'} visible={this.props.isModalOpen} onCancel={this.props.handleModalShow}
                footer={[<Button key="close" type="primary" onClick={this.props.handleModalShow}>关闭</Button>]}>
                <Tabs key={plane.reg} defaultActiveKey={plane.reg?"1":"5"}>
                    <TabPane tab="基础资料" key="1" style={{align:'center'}} disabled={plane.reg===""}>
                        <PlaneInfoBox key={plane.reg} plane={plane} planeinfobox={this.state.planeinfobox}/>
                    </TabPane>
                    <TabPane tab="本机照片" key="2" style={{align:'center'}} disabled={this.state.planeInfo.reg===""}>
                        <Row Row align='middle' justify='center'>
                            {this.state.photos.map((url)=>
                            <Card hoverable style={{ width: '22vw' }}>
                                <Image key={url} src={url} preview={true}/>
                            </Card>)}
                        </Row>
                    </TabPane>
                    <TabPane tab="近期轨迹" key="3" style={{align:'center'}} disabled={this.state.planeInfo.reg===""}>
                        <PlaneTrackMap key={this.state.planeInfo.reg+this.state.planeInfo.icao} tracks={this.state.recenttracks}/>
                    </TabPane>
                    <TabPane tab="活动统计" key="4" style={{align:'center'}} disabled={this.state.planeInfo.reg===""}>
                        <PlaneStatistic key={this.state.planeInfo.reg+this.state.planeInfo.icao} tracks={this.state.recenttracks}/>
                    </TabPane>
                    <TabPane tab="机型资料" key="5" style={{align:'center'}}>
                        <PlaneTypeInfoBox label={this.state.planeInfo.type} wiki={this.state.planetypewiki} infobox={this.state.typeInfoBox}/>
                    </TabPane>
                </Tabs>  
            </Modal>
        )
    }
}
